var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex",staticStyle:{"height":"100%"}},[_c('SideNav',{attrs:{"parent":"employees"}}),_c('AllEmployees')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }